module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared-components/cotizacion/cotizacion.component.html
// module id = ./src/app/shared-components/cotizacion/cotizacion.component.html
// module chunks = main